<template>
  <div>
    <div class="page">
      <div class="page__title">
        {{ title }}
      </div>
      <div class="page__desc" v-html="message"></div>
    </div>
    <div class="page__button">
      <div>
        <SharedButton class="s-btn-bg-primary" @click="cancel">
          關閉
        </SharedButton>
      </div>
    </div>
  </div>
</template>

<script>
import SharedButton from "@/components/Page/Liff/Shared/Button.vue";
import liff from "@line/liff";

export default {
  components: {
    SharedButton,
  },
  computed: {
    type() {
      return this.$route.params.type;
    },
    title() {
      switch (this.type) {
        case "field_missed":
          return this.getModuleConfig("external_member_customer_bind.field_missed.title");
        default:
          return "錯誤";
      }
    },
    message() {
      switch (this.type) {
        case "field_missed":
          return this.getModuleConfig("external_member_customer_bind.field_missed.message");
        default:
          return "發生錯誤，請與客服人員聯繫";
      }
    },
  },
  methods: {
    getModuleConfig(key) {
      return this.$store.getters["liffModule/getConfig"]("member_register", key);
    },
    cancel() {
      liff.closeWindow();
    },
  },
};
</script>

<style lang="scss" scoped>
</style>
